import classNames from "classnames";
import React, { FC } from "react";

interface ReportSidebarItemProps {
  title: string;
  onClick: () => void;
  isSelected: boolean;
}

const ReportSidebarItem: FC<ReportSidebarItemProps> = ({
  onClick,
  isSelected,
  title,
}) => {
  return (
    <button
      type="button"
      className={classNames(
        `
        pl-3 text-start text-[12px] h-auto 
        hover:bg-blue-500 hover:text-white
        `,
        {
          "bg-blue-500 text-white": isSelected,
        }
      )}
      onClick={onClick}
    >
      {title}
    </button>
  );
};

export { ReportSidebarItem };
